import React from 'react';
import AccessDeniedPanel from './AccessDeniedPanel';

const Error403 = () => (
  <div className="tw-min-h-screen tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 tw-overflow-y-auto tw-py-8">
    <AccessDeniedPanel />
  </div>
);

export default Error403;
